var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1 49.8375V57.8526",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7057 29.1C44.7057 37.8668 37.7164 44.9764 29.1 44.9764C20.4836 44.9764 13.4942 37.8668 13.4942 29.1C13.4942 20.3333 20.4803 13.2236 29.1 13.2236C37.7197 13.2236 44.7057 20.3299 44.7057 29.1Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1 48.4477C28.5721 48.4477 28.1445 48.02 28.1445 47.4921C28.1445 46.9643 28.5721 46.5366 29.1 46.5366C29.6279 46.5366 30.0555 46.9643 30.0555 47.4921C30.0555 48.02 29.6279 48.4477 29.1 48.4477Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1 8.36244V0.347412",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1 9.75232C29.6279 9.75232 30.0555 10.18 30.0555 10.7078C30.0555 11.2357 29.6279 11.6634 29.1 11.6634C28.5721 11.6634 28.1445 11.2357 28.1445 10.7078C28.1445 10.18 28.5721 9.75232 29.1 9.75232Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36249 29.1H0.347462",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75234 29.1001C9.75234 28.5722 10.18 28.1445 10.7079 28.1445C11.2357 28.1445 11.6634 28.5722 11.6634 29.1001C11.6634 29.6279 11.2357 30.0556 10.7079 30.0556C10.18 30.0556 9.75234 29.6279 9.75234 29.1001Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8375 29.1H57.8525",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4477 29.1001C48.4477 29.6279 48.02 30.0556 47.4921 30.0556C46.9643 30.0556 46.5366 29.6279 46.5366 29.1001C46.5366 28.5722 46.9643 28.1445 47.4921 28.1445C48.02 28.1445 48.4477 28.5722 48.4477 29.1001Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1752 39.8447C34.9567 41.5519 32.1971 42.5642 29.2002 42.5642C21.8902 42.5642 15.9666 36.5371 15.9666 29.1C15.9666 21.663 21.8902 15.6359 29.2002 15.6359C32.1938 15.6359 34.9534 16.6482 37.1718 18.3521C37.0248 18.3454 36.8745 18.3421 36.7275 18.3421C30.8874 18.3421 26.1532 23.1564 26.1532 29.1C26.1532 35.0437 30.8874 39.8547 36.7275 39.8547C36.8745 39.8547 37.0248 39.8513 37.1752 39.8413V39.8447Z",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9511 40.4026L12.2848 46.0689",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0689 12.2848L40.4026 17.9511",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7974 17.7974L12.1311 12.1311",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9152 45.9152L40.2489 40.2489",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9559 43.8304L19.8622 51.2241",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3044 7.14636L35.2107 14.54",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2359 22.9727L6.84234 19.8789",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92 38.3212L43.5264 35.2274",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4364 35.3075L7.01941 38.3478",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2307 20.223L43.8137 23.2633",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0194 14.393L19.9791 6.97937",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.104 51.1872L35.0637 43.7736",
    stroke: "#FFCD83",
    strokeWidth: 2.07,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9534 18.4757V26.768",
    stroke: "#FFCD83",
    strokeWidth: 0.83,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6061 29.1C36.3833 29.5578 35.4145 30.5233 34.9534 31.7428C34.4924 30.5233 33.5235 29.5544 32.304 29.1C33.5268 28.639 34.4924 27.6734 34.9534 26.454C35.4145 27.6734 36.3833 28.6423 37.6061 29.1Z",
    fill: "#FFCD83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8277 30.9743C35.6417 30.4331 34.2685 30.4297 33.0825 30.9676C33.6204 29.7816 33.617 28.4084 33.0791 27.2257C34.2685 27.7636 35.635 27.7636 36.8244 27.2257C36.2865 28.4118 36.2898 29.7849 36.8277 30.971V30.9743Z",
    fill: "#FFCD83"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.2,
    height: 58.2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.0a24175e1f89f1211cb2838b72e4615d.svg";
export { ForwardRef as ReactComponent };